/* pdf.icon.svg.js */

module.exports = {
    icon: `<svg viewBox="0 0 64 64" preserveAspectRatio="none">
            <g>
                <g>
                    <g>
                        <g>
                            <rect class="foreground-gl" y="56" width="64" height="8"/>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <polygon class="foreground-gl" points="50,28 32,50.1 14,28 26,28 26,0 38,0 38,28"/>
                        </g>
                    </g>
                </g>
            </g>
		</svg>`
};
